import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=116d4674&"
import script from "./InventoryDashboard.vue?vue&type=script&lang=ts&"
export * from "./InventoryDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports